'use client';

import { useEffect } from 'react';
import { globalAbortController } from './abort-controller';

export default function FetchPatchProvider() {
  useEffect(() => {
    const originalFetch = window.fetch;

    window.fetch = function (input, init = {}) {
      return originalFetch(input, {
        ...init,
        signal: globalAbortController.signal,
      });
    };
  }, []);
  return null;
}
